import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { AppProvider, Page, Frame, DataTable, Card, Link, Heading } from '@shopify/polaris';
import debounce from 'lodash/debounce';
import AutocompleteSearch from "@presentational/AutocompleteSearch";
import ItemLink from '@presentational/ItemLink';

import axios from '@utils/axios';

const propTypes = {
  sellerUsers: PropTypes.array.isRequired,

  filterURL: PropTypes.string.isRequired,
}

const defaultProps = {

}

const GoodsMovedLogsLookup = (props) => {
  console.log("PP", props)
  const [userId, setUserId] = useState(null);
  const [rows, setRows] = useState([]);

  const submitFilter = async (selectedUserId) => {
    console.log(selectedUserId);
    try {
      const response = await axios.post(props.filterURL, { user_id: selectedUserId } );
      const { data } = response;
      if(data){
        console.log("D",data);
        setRows( buildRows(data.logs) );
      }
    } catch (error) {
      console.log(error);
      alert("Ocurrio un error de conexión.")
    }
  }

  // const debouncedFilter = useCallback( debounce(submitFilter, 400), [] );

  const clearUserSearch = () => {
    setUserId(null);
  }

  const handleUserChange = (selectedValue) => {
    setUserId(selectedValue);
    submitFilter(selectedValue)
  }

  const buildRows = (logs) => {
    return logs.map( (log) => {
      // const positive = log.kind == "goods_in";
      // positive ? qtyTotal += log.quantity : qtyTotal -= log.quantity;
      return [
        log.title,
        log.sku,
        log.quantity,
        log.amount_money,
        <ItemLink url={ props.transferURLBase.replace("URL_ID", log.transfer_id) } content={ `#${log.transfer_id}` } />,
        I18n.l("time.formats.long", log.goods_note_date),
      ]
    });
  }

  return (
    <AppProvider>
      <Page fullWidth title="Logs">
        <AutocompleteSearch
          placeholder = "Seleccionar Seller..."
          filterOptions = { props.sellerUsers }
          label = "Seller"
          onClearCallback={ clearUserSearch }
          searchDelay={ 100 }
          onSelectionCallback={ (selectedOptions) => handleUserChange(selectedOptions[0]) }
        />
        <Card>
          <DataTable
            rows={rows}
            headings={[ 
              "Producto",
              "SKU",
              'Cantidad',
              'Monto',
              'Entrega APU',
              'Fecha' 
            ]}
            columnContentTypes={['text', 'text', 'number', 'numeric', 'text', 'text']}
          />

          { rows.length == 0 && !!userId && 
            <Card.Section>
              <Heading>No se encontraron resultados...</Heading>
            </Card.Section> 
          }
        </Card>
      </Page>
    </AppProvider>
  )
};

GoodsMovedLogsLookup.propTypes = propTypes;
GoodsMovedLogsLookup.defaultProps = defaultProps;

export default GoodsMovedLogsLookup;